/**
 * Dimension Picker - Inline Selection v1.1
 * Boutons simples pour sélection de dimensions
 * Compatible ES5 pour Shopify
 */

(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initDimensionPicker();
    observeDynamicContent();
  }

  function initDimensionPicker() {
    var containers = document.querySelectorAll('.dimension-picker-container');
    for (var i = 0; i < containers.length; i++) {
      var container = containers[i];
      if (container.dataset.initialized) continue;
      container.dataset.initialized = 'true';
      
      var buttons = container.querySelectorAll('.dimension-btn');
      for (var j = 0; j < buttons.length; j++) {
        buttons[j].addEventListener('click', handleButtonClick);
      }
    }
  }

  function handleButtonClick(e) {
    var button = e.currentTarget;
    var container = button.closest('.dimension-picker-container');
    
    if (button.classList.contains('is-unavailable')) {
      return;
    }
    
    // Désélectionner tous les boutons
    var allButtons = container.querySelectorAll('.dimension-btn');
    for (var i = 0; i < allButtons.length; i++) {
      allButtons[i].classList.remove('is-selected');
    }
    
    // Sélectionner ce bouton
    button.classList.add('is-selected');
    
    // Récupérer les données
    var variantId = button.dataset.variantId;
    var sizeValue = button.dataset.sizeValue;
    var formValue = button.dataset.formValue;
    
    // Mettre à jour les sélecteurs natifs cachés
    updateNativeSelectors(button, sizeValue, formValue);
    
    // Mettre à jour l'URL
    if (variantId) {
      updateURL(variantId);
    }
    
    // Déclencher le changement
    triggerVariantChange(button.closest('form') || button.closest('.product-form'));
  }

  function updateNativeSelectors(button, sizeValue, formValue) {
    var form = button.closest('form') || button.closest('.product-form') || document;
    
    var selects = form.querySelectorAll('select');
    var radios = form.querySelectorAll('input[type="radio"]');
    
    for (var i = 0; i < selects.length; i++) {
      var select = selects[i];
      var label = (select.name || '').toLowerCase();
      
      if (sizeValue && (label.indexOf('taille') > -1 || label.indexOf('size') > -1 || label.indexOf('dimension') > -1)) {
        for (var j = 0; j < select.options.length; j++) {
          if (select.options[j].value === sizeValue) {
            select.selectedIndex = j;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
      }
      
      if (formValue && label.indexOf('forme') > -1) {
        for (var k = 0; k < select.options.length; k++) {
          if (select.options[k].value === formValue) {
            select.selectedIndex = k;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
      }
    }
    
    for (var m = 0; m < radios.length; m++) {
      var radio = radios[m];
      if (sizeValue && radio.value === sizeValue) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (formValue && radio.value === formValue) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function updateURL(variantId) {
    if (window.history && window.history.replaceState) {
      var url = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variantId;
      window.history.replaceState({}, '', url);
    }
  }

  function triggerVariantChange(form) {
    if (form) {
      form.dispatchEvent(new Event('change', { bubbles: true }));
    }
    document.dispatchEvent(new CustomEvent('variant:changed'));
  }

  function observeDynamicContent() {
    if (typeof MutationObserver === 'undefined') return;
    
    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.addedNodes.length) {
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var node = mutation.addedNodes[j];
            if (node.nodeType === 1) {
              var containers = node.querySelectorAll ? node.querySelectorAll('.dimension-picker-container') : [];
              if (containers.length || (node.classList && node.classList.contains('dimension-picker-container'))) {
                setTimeout(initDimensionPicker, 100);
              }
            }
          }
        }
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

})();